import React from 'react';
import {Switch, Route} from 'react-router-dom';
import Meta from '../../../../model/Meta';

/* Steps */
import DefaultView from './DefaultView';
import DeedOfSaleOfMotorVehicleStep1 from './DeedOfSaleOfMotorVehicleStep1';
import DeedOfSaleOfMotorVehicleStep2 from './DeedOfSaleOfMotorVehicleStep2';
import DeedOfSaleOfMotorVehicleStep3 from './DeedOfSaleOfMotorVehicleStep3';
import DeedOfSaleOfMotorVehicleStep4 from './DeedOfSaleOfMotorVehicleStep4';
import DeedOfSaleOfMotorVehicleStep5 from './DeedOfSaleOfMotorVehicleStep5';
import Ty from './Ty';

const DeedOfSaleOfMotorVehicle = (props)=>{
    let basePath = "/contracts/business/deed-of-sale-of-motor-vehicle";
    
    const meta = {
        title: "Deed of sale of motor vehicle Contract",
        description: "Create your custom Deed of sale of motor vehicle Contract free"
    }

	return (
		<div className="page page-inner page-contract">
            <Meta {...meta}/>
            <div className="container-fluid">
                <div className="p-0">
                    <div className="page-content py-3">

                        <Switch>
                            <Route path={basePath+"/1"} component={DeedOfSaleOfMotorVehicleStep1} />
                            <Route path={basePath+"/2"} component={DeedOfSaleOfMotorVehicleStep2} />
                            <Route path={basePath+"/3"} component={DeedOfSaleOfMotorVehicleStep3} />
                            <Route path={basePath+"/4"} component={DeedOfSaleOfMotorVehicleStep4} />
                            <Route path={basePath+"/5"} component={DeedOfSaleOfMotorVehicleStep5} />
                            <Route path={basePath+"/ty"} component={Ty} />
                            <Route component={DefaultView} />
                        </Switch>

                    </div>
                </div>
            </div>
        </div>
	);
}

export default DeedOfSaleOfMotorVehicle;


// WEBPACK FOOTER //
// ./src/pages/contracts/business/deed-of-sale-of-motor-vehicle/DeedOfSaleOfMotorVehicle.js